<p-progressSpinner class="w-100 text-center soc-manager-spinner" *ngIf="spinner"></p-progressSpinner>
<div class="panel-wrapper">
  <div class="pb-4 text-center ">
    <h4>{{'PRODUCT.ARE_YOU_START_TRIAL' | translate}}?</h4>
  </div>
  <div class="d-flex flex-row justify-content-between">
    <button class="create-btn w-45 mt-0" (click)="startTrial()">{{'YES' | translate}}</button>
    <button class="btn-outline-transparent w-45" (click)="cancel()">{{'NO' | translate}}</button>
  </div>
</div>